import React from 'react';
import { AlertTriangle } from 'lucide-react';

const ProblemSection = () => {
  const problems = [
    {
      title: 'Missing Assets',
      image: 'https://images.unsplash.com/photo-1681731059898-72407df8431a',
      description: 'Lost crates and containers cost thousands annually'
    },
    {
      title: 'No Visibility',
      image: 'https://images.unsplash.com/photo-1734510722516-5a558dc910d2',
      description: 'Manual tracking is slow, error-prone, and incomplete'
    },
    {
      title: 'Transport Dependencies',
      image: 'https://images.pexels.com/photos/1267329/pexels-photo-1267329.jpeg',
      description: 'Trucks leave without proper documentation'
    },
    {
      title: 'GPS Too Expensive',
      image: 'https://images.unsplash.com/photo-1759300635757-19ab99f4cfed',
      description: 'Traditional GPS tracking requires costly SIM subscriptions'
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-50 rounded-full mb-4">
            <AlertTriangle className="w-5 h-5 text-red-600" />
            <span className="text-red-600 font-semibold text-sm">The Problem</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What's Broken Today
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Without proper tracking, businesses lose millions in returnable packaging assets every year
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {problems.map((problem, index) => (
            <div key={index} className="group relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300">
              <div className="aspect-[4/3] relative overflow-hidden">
                <img 
                  src={problem.image}
                  alt={problem.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-xl font-bold text-white mb-2">{problem.title}</h3>
                <p className="text-gray-300 text-sm">{problem.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
